<ca-element-loader [loading]="loading" [translucent]="true">
  <mat-chip-list class="relationships" multiple *ngIf="categories">
    <ng-container *ngFor="let category of categories">
      <ng-container [ngSwitch]="category.name">
        <ca-animated-category
          *ngSwitchCase="'Christmas'"
          [category]="category"
          [selected]="_selected | arrayIncludes : category.id"
          (toggleEvent)="toggle(category.id)"
        ></ca-animated-category>
        <ca-animated-category
          *ngSwitchCase="'Easter'"
          [category]="category"
          [selected]="_selected | arrayIncludes : category.id"
          (toggleEvent)="toggle(category.id)"
        ></ca-animated-category>
        <ca-animated-category
          *ngSwitchCase="'Elf'"
          [category]="category"
          [selected]="_selected | arrayIncludes : category.id"
          (toggleEvent)="toggle(category.id)"
        ></ca-animated-category>
        <ca-animated-category
          *ngSwitchCase="'Olympics'"
          [category]="category"
          [selected]="_selected | arrayIncludes : category.id"
          (toggleEvent)="toggle(category.id)"
        ></ca-animated-category>
        <ca-animated-category
          *ngSwitchCase="'Halloween'"
          [category]="category"
          [selected]="_selected | arrayIncludes : category.id"
          (toggleEvent)="toggle(category.id)"
        ></ca-animated-category>
        <mat-chip
          *ngSwitchDefault
          [value]="category.id"
          [selected]="_selected | arrayIncludes : category.id"
          (click)="toggle(category.id)"
          color="secondary"
        >
          <ca-badge class="transparent" [name]="category.icon"></ca-badge>
          {{ category.name }}
        </mat-chip>
      </ng-container>
    </ng-container>
  </mat-chip-list>
</ca-element-loader>
